var exports = {
  "n": "PerksButton.module__link___YnRIQ2",
};

module.exports = exports;
